<script setup lang="ts">
import type { ComponentPublicInstance } from 'vue';

import type { ChartGeometry } from './chart-geometry';

defineProps<{
  bindElement: (element: Element | ComponentPublicInstance | null) => void;
  formatter: (value: number) => string;
  geometry: ChartGeometry;
  isMeasured: boolean;
  label: string;
  scale: (value: number) => number;
  ticks: readonly number[];
  titleId: string;
}>();

const emit = defineEmits<{
  cancel: [event: PointerEvent];
  leave: [event: PointerEvent];
  move: [event: PointerEvent];
}>();
</script>

<template>
  <div class="relative">
    <svg
      :ref="bindElement"
      class="block h-64 w-full touch-pan-y md:h-80"
      role="img"
      :aria-labelledby="titleId"
      @pointermove="emit('move', $event)"
      @pointerleave="emit('leave', $event)"
      @pointercancel="emit('cancel', $event)"
    >
      <title :id="titleId">{{ label }}</title>
      <template v-if="isMeasured">
        <g aria-hidden="true">
          <g
            v-for="tick in ticks"
            :key="tick"
          >
            <line
              :x1="geometry.plotLeft"
              :x2="geometry.plotRight"
              :y1="scale(tick)"
              :y2="scale(tick)"
              stroke="var(--border-soft)"
              stroke-width="1"
              vector-effect="non-scaling-stroke"
            />
            <text
              :x="geometry.plotLeft - 10"
              :y="scale(tick) + 4"
              text-anchor="end"
              fill="var(--text-secondary)"
              font-size="11"
            >
              {{ formatter(tick) }}
            </text>
          </g>
        </g>
        <slot />
      </template>
    </svg>
    <slot name="tooltip" />
  </div>
</template>
